import { render } from "./ClientSelection.vue?vue&type=template&id=6166ee84&scoped=true"
import script from "./ClientSelection.vue?vue&type=script&lang=js"
export * from "./ClientSelection.vue?vue&type=script&lang=js"

import "./ClientSelection.vue?vue&type=style&index=0&id=6166ee84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6166ee84"]])

export default __exports__